import NextImage from 'next/future/image'
import ComponentStyle from '../ComponentStyle'

export default function ComponentBlocksBanner ({ Image, Title, Button, BackgroundOverlay }) {
  return (
    <div className="cms__component-banner col-12">
      <NextImage
        alt=""
        src={`${process.env.NEXT_PUBLIC_CMS_URL}${Image.data.attributes.url}`}
        width={Image.data.attributes.width}
        height={Image.data.attributes.height}
        className="img-fluid w-100 h-100 object-fit-cover"
      />
      {
        BackgroundOverlay && (
          <div className="w-100 h-100 bg-opacity-50 bg-dark"></div>
        )
      }
      <div className="container py-5 text-white">
        {
          Title && (
            <div dangerouslySetInnerHTML={{ __html: Title }}></div>
          )
        }
        {
          Button && (
            <ComponentStyle config={{
              Margin: Button.Margin,
              TextAlignment: Button.TextAlignment,
              Size: Button.Size
            }}
            >
              <a
                href={Button.Link}
                className={`btn btn-${Button.Variant}`}
                target="_blank"
                rel="noreferrer"
              >
                {Button.Text}
              </a>
            </ComponentStyle>
          )
        }
      </div>
    </div>
  )
}
